var React = require('react');

function Back (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"backgroundrect","width":"100%","height":"100%","x":"0","y":"0","fill":"none","stroke":"none","key":0}),React.createElement("g",{"className":"currentLayer","key":1},React.createElement("g",{"id":"Mobilmeny","stroke":"none","strokeWidth":"1","className":"selected","fillOpacity":"1"},React.createElement("g",{"id":"Group-2"},React.createElement("g",{"id":"angle1","transform":"rotate(90 9.68 5.505)"},React.createElement("path",{"d":"M17.978 7.696l-.695-.678a.445.445 0 00-.64 0l-5.467 5.336-5.467-5.336a.444.444 0 00-.64 0l-.695.679a.424.424 0 00-.14.312c0 .118.047.222.14.312l6.482 6.328a.445.445 0 00.64 0l6.482-6.328a.424.424 0 00.139-.312.425.425 0 00-.139-.313z","id":"Shape"})))))]);
}

Back.defaultProps = {"width":"9","height":"14"};

module.exports = Back;

Back.default = Back;
